import { IcClose, IcPlus } from '@assets/icons/24x24';
import { For, HStack, Icon, ListCollection, Popover, Portal, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';

import { ButtonWithIcon } from '../buttonToggle/ButtonWithIcon';
import CheckboxList from './CheckboxList';

export type Option = {
  value: string;
  label: string;
  disabled?: boolean;
};

type Props<T extends Option> = {
  label: string;
  values: string[];
  collection: ListCollection<T>;
  onChange: (value: string[]) => void;
};

export default function MultiSelect<T extends Option>({ label, values, collection, onChange }: Readonly<Props<T>>) {
  const [open, setOpen] = useState(false);
  return (
    <VStack gap={2} width="100%" alignItems="start">
      <Popover.Root
        open={open}
        positioning={{ placement: 'bottom-start' }}
        onOpenChange={() => {
          setOpen(!open);
        }}
      >
        <Popover.Trigger asChild>
          <ButtonWithIcon
            width="min-content"
            className="group"
            label={label}
            side="right"
            icon={<Icon boxSize="24px" as={IcPlus} color="neutral.300" _groupHover={{ color: 'skyBlue.500' }} />}
          />
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content>
              {open && <CheckboxList values={values} collection={collection} onChange={onChange} />}
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
      <HStack gap={1} flexWrap="wrap" width="100%">
        <For each={values}>
          {(item) => (
            <HStack key={item} gap={1} padding={1} backgroundColor="neutral.900">
              <Text>{collection.find(item)?.label ?? item}</Text>
              <Icon
                as={IcClose}
                color="neutral.300"
                _hover={{ color: 'skyBlue.500' }}
                cursor="pointer"
                onClick={() => onChange(values.filter((v) => item !== v))}
              />
            </HStack>
          )}
        </For>
      </HStack>
    </VStack>
  );
}
